import React, { ReactElement, useState } from "react";
import { FormattedMessage } from "react-intl";

import { isNil } from "ramda";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

import { ILocations, IServerTypes } from "types/api/serversApiInterface";

import ServerSizeBox from "../ServerSizeBox";

const ServerSize = ({
 description,
 typesList,
 serverSize,
 sizeLoading,
 disableNext,
 resetData,
 handleOpen,
 setData
}: {
 description: string;
 typesList: Array<IServerTypes>;
 serverSize: number;
 sizeLoading: boolean;
 disableNext: boolean;
 resetData: () => void;
 handleOpen: () => void;
 setData: (section: string, value: string | number | boolean | IServerTypes | ILocations) => void;
}): ReactElement => {
 const [tabValue, setTabValue] = useState<number>(
  serverSize !== 0
   ? typesList.find((element) => element.id === serverSize)?.name.includes("FS")
     ? 2
     : typesList.find((element) => element.id === serverSize)?.name.includes("FS")
     ? 1
     : 0
   : 0
 );

 const handleChange = (event: React.SyntheticEvent, newValue: number) => {
  setTabValue(newValue);
 };

 return !sizeLoading ? (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2, textAlign: "left" }}>
   <Typography variant="unboundedTitle" fontSize={18}>
    <FormattedMessage id="server.add.selectType" />
   </Typography>
   <Stack spacing={2} mt={2}>
    <Typography textAlign="left" variant="subtitle2">
     <FormattedMessage id={description} />
    </Typography>
    <Box sx={{ width: "100%", typography: "body1" }}>
     <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
       <Tab label="Standard" />
       <Tab label="Dedicated" />
       <Tab label="Storage" />
      </Tabs>
     </Box>
     <Stack
      role="tabpanel"
      hidden={tabValue !== 0}
      id={`simple-tabpanel-${0}`}
      aria-labelledby={`simple-tab-${0}`}>
      {tabValue === 0 && (
       <ServerSizeBox
        selectedSize={serverSize}
        sizesList={typesList.filter((element) => element.name.includes("FP"))}
        selectSize={(size) => {
         setData("serverSize", Number(size));
         const findedServer = typesList.find((element) => element.id === Number(size));
         if (!isNil(findedServer)) {
          setData("serverSizeData", findedServer);
         }
        }}
       />
      )}
     </Stack>
     <Stack
      role="tabpanel"
      hidden={tabValue !== 1}
      id={`simple-tabpanel-${1}`}
      aria-labelledby={`simple-tab-${1}`}>
      {tabValue === 1 && (
       <ServerSizeBox
        selectedSize={serverSize}
        sizesList={typesList.filter((element) => element.name.includes("FD"))}
        selectSize={(size) => {
         setData("serverSize", Number(size));
         const findedServer = typesList.find((element) => element.id === Number(size));
         if (!isNil(findedServer)) {
          setData("serverSizeData", findedServer);
         }
        }}
       />
      )}
     </Stack>
     <Stack
      role="tabpanel"
      hidden={tabValue !== 2}
      id={`simple-tabpanel-${2}`}
      aria-labelledby={`simple-tab-${2}`}>
      {tabValue === 2 && (
       <ServerSizeBox
        selectedSize={serverSize}
        sizesList={typesList.filter((element) => element.name.includes("FS"))}
        selectSize={(size) => {
         setData("serverSize", Number(size));
         const findedServer = typesList.find((element) => element.id === Number(size));
         if (!isNil(findedServer)) {
          setData("serverSizeData", findedServer);
         }
        }}
       />
      )}
     </Stack>
    </Box>
   </Stack>
   <Stack direction="row" justifyContent="flex-end" alignItems="center">
    <Button onClick={resetData} sx={{ mt: 1, mr: 1 }}>
     <FormattedMessage id="server.add.reset" />
    </Button>
    <Button sx={{ mt: 1, mr: 1 }} disabled={disableNext} onClick={handleOpen}>
     <FormattedMessage id="server.add.confirm" />
    </Button>
   </Stack>
  </Paper>
 ) : (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2, textAlign: "left" }}>
   <Typography variant="unboundedTitle" fontSize={18}>
    <FormattedMessage id="server.add.selectType" />
   </Typography>
   <Stack spacing={2} mt={2}>
    <Typography textAlign="left" variant="subtitle2">
     <FormattedMessage id={description} />
    </Typography>
    <Stack direction="row" spacing={2} alignItems="center">
     <CircularProgress />
     <Typography>
      <FormattedMessage id="app.loadingData" />
     </Typography>
    </Stack>
   </Stack>
  </Paper>
 );
};

export default ServerSize;
